<script setup>
import { sidebarHighlight } from '@/utils/sidebarBus'

const serviceItems = [
  {
    icon: '📞',
    label: '电话咨询',
    phone: '17817559362',
    isPhone: true
  },
  {
    icon: '📱',
    label: '微信咨询',
    isWechat: true
  }
]
</script>

<template>
  <div class="customer-service-container">
    <!-- Sidebar -->
    <div class="service-sidebar" :class="{ highlighted: sidebarHighlight }">
      <div v-for="(item, index) in serviceItems" :key="index" class="service-item">
        <div class="icon-wrapper">
          <!-- Phone Icon SVG -->
          <svg v-if="item.isPhone" class="service-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          
          <!-- WeChat Icon Image -->
          <img v-if="item.isWechat" src="@/assets/wechat.png" alt="微信" class="service-icon" />
        </div>
        <span class="label">{{ item.label }}</span>
        
        <!-- Phone Hover Popup -->
        <div v-if="item.isPhone" class="hover-popup phone-popup">
          <p class="popup-title">咨询热线</p>
          <p class="phone-number">{{ item.phone }}</p>
          <p class="popup-desc">周一至周五 8:30-18:00</p>
        </div>
        
        <!-- Wechat QR Hover -->
        <div v-if="item.isWechat" class="hover-popup wechat-popup">
          <img src="@/assets/images/customer-service-qr.png" alt="微信二维码" />
          <p>扫码咨询官方客服</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.customer-service-container {
  position: fixed;
  right: 20px;
  bottom: 100px;
  display: flex;
  align-items: flex-end;
  z-index: 1000;
}

/* Sidebar Styling */
.service-sidebar {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  width: 80px;
  transition: box-shadow 0.3s, transform 0.3s;
}

.service-sidebar.highlighted {
  box-shadow: 0 0 0 3px #fa8c16, 0 4px 24px rgba(250, 140, 22, 0.4);
  transform: scale(1.06);
  animation: pulse-sidebar 0.4s ease 2;
}

@keyframes pulse-sidebar {
  0%   { transform: scale(1.06); }
  50%  { transform: scale(1.10); }
  100% { transform: scale(1.06); }
}

.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 15px 0;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.service-item:hover {
  background-color: #f8faff;
}

.service-item:not(:last-child)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 15%;
  width: 70%;
  height: 1px;
  background-color: #f0f0f0;
}

.icon-wrapper {
  width: 44px;
  height: 44px;
  background: #f0f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0088ff;
  position: relative;
  transition: all 0.2s;
}

.service-icon {
  width: 24px;
  height: 24px;
  display: block;
}

.wechat-color {
  color: #07c160;
}

.service-item:hover .icon-wrapper {
  transform: scale(1.1);
  background-color: #0088ff;
  color: white;
}

/* Specific hover behavior for image icon */
.service-item:hover .icon-wrapper:has(.service-icon:not(svg)) {
  background-color: transparent;
}

.business-icon {
  background: linear-gradient(135deg, #0088ff, #0055ff);
  color: white;
}

.badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background-color: #ff3b30;
  color: white;
  font-size: 10px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.label {
  font-size: 12px;
  color: #555;
  font-weight: 500;
  text-align: center;
}

/* Hover Popups (Generic) */
.hover-popup {
  position: absolute;
  right: 100%;
  bottom: 0;
  margin-right: 20px;
  background: white;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  display: none;
  text-align: center;
  width: 180px;
  z-index: 1002;
}

.service-item:hover .hover-popup {
  display: block;
  animation: slideIn 0.3s ease;
}

/* WeChat Specific */
.wechat-popup img {
  width: 140px;
  height: 140px;
  margin-bottom: 8px;
  display: block;
  margin: 0 auto 8px;
}

.wechat-popup p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

/* Phone Specific */
.phone-popup {
  padding: 18px;
}

.popup-title {
  margin: 0 0 10px;
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.phone-number {
  margin: 0 0 8px;
  font-size: 18px;
  color: #0088ff;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.popup-desc {
  margin: 0;
  font-size: 11px;
  color: #999;
}

/* Consultation Popup Styling */
.consultation-popup {
  position: absolute;
  right: 100%;
  top: 10px;
  margin-right: 20px;
}

.popup-box {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  position: relative;
  min-width: 220px;
  animation: bounceIn 0.5s ease;
}

.close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  border: none;
  background: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
}

.consultant-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #f0f7ff;
}

.text-content {
  display: flex;
  flex-direction: column;
}

.title {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.desc {
  margin: 4px 0 0;
  font-size: 13px;
  color: #777;
}

.arrow {
  position: absolute;
  right: -10px;
  top: 30px;
  width: 0;
  height: 0;
  border-left: 10px solid white;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}

/* Animations */
@keyframes slideIn {
  from { opacity: 0; transform: translateX(10px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes bounceIn {
  0% { opacity: 0; transform: scale(0.8); }
  70% { transform: scale(1.05); }
  100% { opacity: 1; transform: scale(1); }
}

/* Responsive adjustment */
@media (max-width: 768px) {
  .customer-service-container {
    bottom: 20px;
    right: 10px;
  }
  .service-sidebar {
    width: 60px;
  }
  .label {
    font-size: 10px;
  }
  .consultation-popup {
    display: none; /* Hide popup on small screens to save space */
  }
}
</style>
